import styled, { css } from 'styled-components';
export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  min-width:300px;
  flex-direction: column;
  padding:'0.5rem';
  font-size: 0.90rem;
`;
export const Content = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  min-width:300px;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  .add--{
    display: flex;
    width: 100%;
    justify-content: right;
    label{
      display: flex;
      align-items: center;
      gap: 0.2rem;
      margin-bottom: 0.5rem;
      cursor: pointer;
    }
  }
  .search{
    padding: 0;
    height: 2.5rem;
  }
  .back--{
    display: flex;
    align-items: center;
    width: 6rem;
    cursor: pointer;
  }
  .icon--{
    font-size: 2rem;
  }
  .card--Contact{
    display: flex;
    height: 4.5rem;
    flex-direction: row;
    list-style-type: none;
    padding: 0.5em;
    cursor: pointer;
    &:hover{
      background-color: #e8e8e8;
    }
    .avatar--{
      display: flex;
      width:4rem;
      height:3.65rem;
      justify-content: center;
      align-items: center;
    }
    .info--{
      display: flex;
      width: calc(100% - 4rem);
      max-width: calc(100% - 4rem);
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      .name{
        display: flex;
        width:  100%;
        height: 50%;
        font-size: 1rem;
        font-weight: 500;
        color: black;
        .name--overflow{
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .description{
        display: flex;
        width: 100%;
        height: 50%;
        font-size: 1rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        border-bottom: 1px solid #eee;
      }
    }
  }
`;
export const ContactsCard = styled.ul`
  display: flex;
  width: 100%;
  height: 100%;
  margin-top: 4px;
  flex-direction: column;
  overflow-y: auto;
  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb{
    background-color: rgb(0, 0, 0,0.2);
  }
  ${({ selected }) =>
    selected &&
    css`
      opacity: 0.6;
      pointer-events: none;
  `}
`;